import { getStoredVersion } from "./appVersion";

/**
 * Sistema operativo real por Client Hints (solo Chrome/Edge). El user-agent de Windows 11
 * sigue diciendo "Windows NT 10.0"; platformVersion >= 13 indica Windows 11.
 * Se pide una vez al cargar (es asincrono) y se reutiliza.
 */
let sistemaReal = null;
try {
  navigator.userAgentData?.getHighEntropyValues?.(["platformVersion"]).then(({ platform, platformVersion }) => {
    if (!platform || !platformVersion) return;
    const mayor = parseInt(platformVersion.split(".")[0], 10);
    if (platform === "Windows") sistemaReal = { so: "Windows", soVersion: mayor >= 13 ? "11" : "10" };
    else if (platform === "macOS") sistemaReal = { so: "macOS", soVersion: platformVersion.split(".").slice(0, 2).join(".") };
    else sistemaReal = { so: platform, soVersion: platformVersion };
  }).catch(() => {});
} catch (_) {}

/**
 * Datos del navegador que se envian al Chat Elite (el servidor anade navegador/SO/dispositivo a partir del
 * user-agent; la IP no se recoge). Solo se usan para dar soporte al AAFF.
 */
export const getContextoNavegador = () => {
  let zonaHoraria = null;
  try {
    zonaHoraria = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch (_) {}

  // navigator.connection solo existe en Chromium (Chrome, Edge, Android)
  const conexion = navigator.connection?.effectiveType || null;

  return {
    pagina: getPaginaActual(),
    idioma: localStorage.getItem("i18nextLng") || navigator.language || null,
    zonaHoraria,
    pantalla: window.screen ? `${window.screen.width}x${window.screen.height}` : null,
    conexion,
    appVersion: getStoredVersion() || null,
    ...(sistemaReal || {}),
  };
};

export const getPaginaActual = () => `${window.location.pathname}${window.location.search}`.slice(0, 500);

// Pantallas del AAFF (routes/AAFF.jsx) -> clave de chatElite.contexto.paginas ({{id}} = el NIF o id de la ruta)
const PANTALLAS = [
  [/^\/?$/, "inicio"],
  [/^\/comunidades\/?$/, "comunidades"],
  [/^\/comunidades\/([^/]+)/, "comunidad"],
  [/^\/proveedores\/?$/, "proveedores"],
  [/^\/proveedores\/([^/]+)/, "proveedor"],
  [/^\/servicios/, "servicios"],
  [/^\/instalaciones\/?$/, "instalaciones"],
  [/^\/instalaciones\/([^/]+)/, "instalacion"],
  [/^\/oficinas/, "oficinas"],
  [/^\/perfil/, "perfil"],
  [/^\/aaff-informes/, "informes"],
  [/^\/informe-riesgos\/([^/]+)/, "informeRiesgos"],
  [/^\/(ia-normativa|laeai)/, "iaNormativa"],
  [/^\/ia-juridica/, "iaJuridica"],
];

/** Nombre de la pantalla para el AAFF ("Comunidad H12345678"); si no es conocida, la ruta. */
export const describirPagina = (ruta, t) => {
  const camino = String(ruta || "").split(/[?#]/)[0];
  for (const [patron, clave] of PANTALLAS) {
    const m = camino.match(patron);
    if (!m) continue;
    let id = m[2] ?? m[1] ?? "";
    try { id = decodeURIComponent(id); } catch (_) {}
    return t(`chatElite.contexto.paginas.${clave}`, { id });
  }
  return camino;
};
